import { createFileRoute } from '@tanstack/react-router';
import { MailPage } from '@pages/mail';

/** Mail-Route (/mail) */
export const Route = createFileRoute('/_authenticated/mail')({
  component: MailPage,
});
